import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-save",
  "use": "icon-save-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-save\"><defs><style type=\"text/css\"></style></defs><path d=\"M950.628 233.373l-160-160A32.004 32.004 0 0 0 768 64H160c-52.935 0-96 43.065-96 96v704c0 52.935 43.065 96 96 96h704c52.935 0 96-43.065 96-96V256a31.999 31.999 0 0 0-9.372-22.627zM320 128h256v158.845c0 17.673 14.327 32 32 32s32-14.327 32-32V128h64v256H320V128z m448 768H256V704h512v192z m128-32c0 17.645-14.355 32-32 32h-32V702c0-34.187-27.813-62-62-62H254c-34.187 0-62 27.813-62 62v194h-32c-17.645 0-32-14.355-32-32V160c0-17.645 14.355-32 32-32h96v258c0 34.187 27.813 62 62 62h388c34.187 0 62-27.813 62-62V141.255l128 128V864z\" p-id=\"15212\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icon/svg/save.svg
// module id = 0Eth
// module chunks = 24